export default {
    data() {
        return {
            type: null,
            saving: false
        }
    },

    computed: {
        buttonText() {
            if (this.saving) {
                return '<i class="fal fa-spinner fa-spin"></i> Saving...';
            }

            if (this.isLastStep) {
                return '<i class="fal fa-check"></i> Submit Report';
            }

            return 'Next <i class="fal fa-arrow-right"></i>';
        },

        step() {
            return this.$route.params.step || this.steps[0].id;
        },

        backPath() {
            if (this.isFirstStep && this.$route.path.includes('edit')) {
                return `/reports/${this.$parent.reportData.id}`;
            }

            if (this.$parent.reportData) {
                return this.prevUrl(this.$parent.reportData.id);
            }

            return '/?page=reports';
        }
    },

    methods: {
        endpoint() {
            let endpoint = ['reports', this.type];
            if (this.$parent.reportData !== null) {
                endpoint.push(this.$parent.reportData.id);
            }
            if (!this.isFirstStep) {
                endpoint.push(this.step);
            }
            return endpoint.join('/');
        },

        nextUrl(id) {
            if (this.isLastStep) {
                return '/reports/list';
            }

            let url = ['reports', id, 'edit', this.nextStep];

            return '/' + url.filter(part => part).join('/');
        },

        prevUrl(id) {
            const url = ['reports', id, 'edit', this.prevStep];

            return '/' + url.filter(part => part).join('/');
        },

        save() {
            if(!this.isLastStep) {
                this.submitForm();
                return;
            }
            this.$swal({
                title: 'Are you sure?',
                html: 'This will submit the report and send it to your manager.',
                confirmButtonText: 'Yes, submit report.',
                showCancelButton: true,
            }).then(() => {
                this.submitForm();
            }).catch(() => {
                //
            });
        },

        submitForm() {
            let form = new FormData(this.$el);
            let endpoint = this.endpoint();

            this.saving = true;

            this.$api('hr').post(endpoint, form)
                .then(({data}) => {
                    if (!this.isLastStep) {
                        this.$noty.success('Saved!')
                    } else {
                        this.$noty.success('The report has been completed.')
                    }

                    this.$router.push(this.nextUrl(data.data.id));

                    this.saving = false
                })
                .catch(() => {
                    this.saving = false
                })
        }
    }

}
